import API from '../../api/api';
import { toast } from 'sonner';
import {
  GET_BARNERS,
  GET_BARNER,
  BARNERS_LOADING,
  BARNERS_ERROR,
  UPDATE_BARNER
  
} from './types';
import { getDataFromFile, saveDataToFile } from '../../actions/local/DataLocal';
import { localStorageKeys } from '../../config/localvalue';

// Action pour récupérer tous les clients
export const getBarners = (filters = {}) => async (dispatch) => {
  dispatch({ type: BARNERS_LOADING });

  const barners = getDataFromFile(localStorageKeys.bannersData) || [];
  dispatch({ type: GET_BARNERS, payload: barners });
  
  try {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.activeOnly) params.append('activeOnly', filters.activeOnly);
    if (filters.status) params.append('status', filters.status);
    if (filters.type) params.append('type', filters.type);

    
    
    const queryString = params.toString();
    const url = `/banners/get_banners${queryString ? '?' + queryString : ''}`;
    
    const res = await API.get(url);
    dispatch({
      type: GET_BARNERS,
      payload: res.data.data
    });
    saveDataToFile( res.data.data, localStorageKeys.bannersData)
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message 
      ? error.response.data.message 
      : 'Erreur lors de la récupération des barners';
    // toast.error(errorMsg);
    dispatch({
      type: BARNERS_ERROR,
      payload: errorMsg
    });
    
    //throw error;
  }
};

// Action pour récupérer un client par son ID
export const getBarnerById = (barnerId) => async (dispatch) => {
  dispatch({ type: BARNERS_LOADING });
  
  try {
    const res = await API.get(`/banners/get_banner/${barnerId}`);
    dispatch({
      type: GET_BARNER,
      payload: res.data.data
    });
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.error 
      ? error.response.data.error 
      : 'Erreur lors de la récupération du slide';
    
    // toast.error(errorMsg);
    
    dispatch({
      type: BARNERS_ERROR,
      payload: errorMsg
    });
    
    //throw error;
  }
};


// create barner
export const createBarner = (barnerData) => async (dispatch) => {
  dispatch({ type: BARNERS_LOADING });
  
  try {
    const res = await API.post('/banners/create_banner', barnerData);

    dispatch({
      type: UPDATE_BARNER,
      payload: res.data.data
    });
    toast.success(res?.data?.message || 'Slide créé avec succès!');
    dispatch(getBarners());
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error?.response?.data?.message
      : 'Erreur lors de la création du slide';

    toast.error(errorMsg);
    dispatch({
      type: BARNERS_ERROR,
      payload: errorMsg
    });

    //throw error;
  }
};



// Action pour mettre à jour le  du barner
export const updateBarner = (id, barnerData) => async (dispatch) => {
  dispatch({ type: BARNERS_LOADING });
  
  try {
    const res = await API.put(`/banners/update_banner/${id}`, barnerData);
    
    
    dispatch({
      type: UPDATE_BARNER,
      payload: res.data.data
    });
    toast.success(res.data.message || 'Slide mis à jour avec succès!');
    dispatch(getBarners());
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la mise à jour du slide';
    
    toast.error(errorMsg);
    
    dispatch({
      type: BARNERS_ERROR,
      payload: errorMsg
    });
    
    //throw error;
  }
};







// Action pour mettre à jour le  du barner
export const deleteBarner = (id, ) => async (dispatch) => {
  dispatch({ type: BARNERS_LOADING });
  
  try {
    const res = await API.delete(`/banners/delete_banner/${id}`);
    
    dispatch({
      type: UPDATE_BARNER,
      payload: res.data.data
    });
    toast.success(res?.data?.message || 'Slide supprimé avec succès!');
    return res.data.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.message
      ? error.response.data.message
      : 'Erreur lors de la suppression du slide';

    toast.error(errorMsg);

    dispatch({
      type: BARNERS_ERROR,
      payload: errorMsg
    });
    dispatch(getBarners());

    //throw error;
  }
};
